import { OrdersPage as MainOrdersPage } from '@pages/Orders';

export const OrdersPage = () => (
    <div className="smetter-css w-full">
        <MainOrdersPage />
    </div>
);
